import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { reduxForm } from "redux-form";
import { FormField } from "./ReduxFormUtils";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
import "react-toastify/dist/ReactToastify.css";
import "../MasterFormStyles.scss";
import "primeicons/primeicons.css";
import AddedDetails from "../MasterUtils/Components/AddedDetailsSection/AddedDetailsSection";
import PropTypes from "prop-types";
import {
  WorkflowStatuses,
  INVALID_UPDATE_MSG,
} from "../MasterUtils/MasterFormUtils";
import RemarkDetails from "../MasterUtils/Components/RemarkSection/RemarkDetails";
import { getIsMasterDataLoading } from "../../../Store/Masters/MastersSelectors";
import { useTranslation } from "react-i18next";

const AddUpdateForm = (props) => {
  const {
    onClose,
    mode,
    selectedItems,
    formConfig,
    handleSubmit,
    reset,
    masterType,
    addedData,
    detailsShow,
    optionsData,
    showApproveRejectBtn,
    deleteApproveRejectBtn,
    initialValues,
    enableFileDocument,
    dispatch,
    change,
    form,
  } = props;
  if (masterType === 'activityMaster') {
  optionsData.incentiveOptions = {
    isLoading: false,
    options: [
      {
        value: 'state',
        label: 'State',
        incentiveId: 'state',
        incentiveName: 'State'
      },
       {
        value: 'central',
        label: 'Central',
        incentiveId: 'central',
        incentiveName: 'Central'
      }
    ]
  };
}
  if (masterType === 'activityMaster') {
  optionsData.incentiveOptions = {
    isLoading: false,
    options: [
      {
        value: 'state',
        label: 'State',
        incentiveId: 'state',
        incentiveName: 'State'
      },
       {
        value: 'central',
        label: 'Central',
        incentiveId: 'central',
        incentiveName: 'Central'
      }
    ]
  };
}
  const { t } = useTranslation("master");
  const { title, fields } = formConfig;
  const remarks = getRemarksFromInitialValues(initialValues);

  const [showRemarks, setShowRemarks] = useState(remarks.length > 0);
  const isApiLoading = useSelector(getIsMasterDataLoading);

  const isNotEditable = getIsNotEditable(mode, selectedItems);

  useEffect(() => {
    const confirmPasswordField = fields.find(
      (field) => field.name === "confirmPassword"
    );

    if (confirmPasswordField) {
      confirmPasswordField.validate = [
        (value, allValues) =>
          value !== allValues.password
            ? t("Passwords do not match.")
            : undefined,
      ];
    }
  }, [fields, t]);

  const HandleReject = () => {
    setShowRemarks(true);
  };

  const renderMultiUpdateForm = () => {
    let editableFields = [];
    let readOnlyFields = [];
    fields.forEach((field) => {
      if (field.showWhenMultiUpdate) {
        editableFields.push(
          <FormField
            key={field.name}
            {...field}
            change={props.change}
            formName={form}
            dropdownOptions={optionsData[field.options]}
            mode={mode}
            masterType={masterType}
          />
        );
      } else if (field.pluralLabel) {
        let d = "";
        selectedItems.forEach((item) => {
          if (item[field.name]) {
            d += item[field.name] + ", ";
          }
        });

        d = d.slice(0, -2);

        readOnlyFields.push(readOnlyFieldComponent([field.pluralLabel], d));
      }
    });

    return (
      <>
        {editableFields}
        <div className={"col-12 flex pt-5"}>{readOnlyFields}</div>
      </>
    );
  };
  const setFieldDisabledBasedOnSelectedItems = (field) => {
    if (selectedItems.length > 0 && selectedItems[0].status === "Invalid") {
      field.disabled = true;
    } else {
      field.disabled = false;
    }
  };
  const renderField = (field) => {
    if (
      mode === "Update" &&
      (field.name === "password" || field.name === "confirmPassword")
    ) {
      return null;
    }
    if (field.name === "attachedDoc" && enableFileDocument === false) {
      setFieldDisabledBasedOnSelectedItems(field);
    } else if (enableFileDocument === true && field.name === "attachedDoc") {
      field.disabled = false;
    } 
    return (
      <FormField
        key={field.name}
        {...field}
        formName={form}
        change={props.change}
        dropdownOptions={optionsData[field.options]}
        initialValues={initialValues}
        enableFileDocument={enableFileDocument}
        mode={mode}
        masterType={masterType}
      />
    );
  };
  const renderForm = () => {
    if (!fields || fields.length === 0) return null;
    if (selectedItems && selectedItems.length > 1) {
      return renderMultiUpdateForm();
    } else {
      return fields.map(renderField);
    }
  };

  /**While add, approve or update we have to send remarks = '' */
  const onHandleAddApproveUpdate = () => {
    dispatch(change("remarks", ""));
    setTimeout(() => {
      handleSubmit();
    }, 10);
  };

  return (
    <>
      <div className="pl-3 pt-1 pr-3">
        <div className="flex flex-wrap align-items-center justify-content-between ">
          <div className="form_title">
            {getFormTitle(mode, title, deleteApproveRejectBtn, t)}
          </div>
          {isNotEditable && (
            <div className="actionTxt"> {INVALID_UPDATE_MSG} </div>
          )}
        </div>
        <div className="master-form">
          <div className="flex grid p-3 ">{renderForm()}</div>

          <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
            <Button
              className="formBtn-clear"
              data-testid="clear"
              label={getClearCancelButtonLabelTooltip(mode, t)}
              tooltip={getClearCancelButtonLabelTooltip(mode, t)}
              tooltipOptions={{ position: "bottom", event: "both" }}
              onClick={() => {
                if (mode === "Update" || mode === "Approve") {
                  onClose();
                }
                reset();
              }}
              disabled={isNotEditable}
            />
            {showApproveRejectBtn ? (
              <>
                <Button
                  className="formBtn-clear"
                  data-testid="reject"
                  label={getRejectButtonLabelTooltip(deleteApproveRejectBtn, t)}
                  tooltip={getRejectButtonLabelTooltip(
                    deleteApproveRejectBtn,
                    t
                  )}
                  tooltipOptions={{ position: "bottom", event: "both" }}
                  onClick={HandleReject}
                  disabled={isNotEditable}
                />
                <Button
                  className="formBtn-primary"
                  data-testid="clear"
                  label={getApproveButtonLabelTooltip(
                    deleteApproveRejectBtn,
                    t
                  )}
                  tooltip={getApproveButtonLabelTooltip(
                    deleteApproveRejectBtn,
                    t
                  )}
                  tooltipOptions={{ position: "bottom", event: "both" }}
                  onClick={handleSubmit}
                  disabled={isNotEditable}
                />
              </>
            ) : (
              <Button
                data-testid="submit"
                className="formBtn-primary"
                label={getSubmitButtonLabelTooltip(mode, title, t)}
                tooltip={getSubmitButtonLabelTooltip(mode, title, t)}
                tooltipOptions={{ position: "bottom", event: "both" }}
                onClick={onHandleAddApproveUpdate}
                disabled={isNotEditable}
              />
            )}
          </div>
        </div>
      </div>
      {detailsShow ? renderDetails(isApiLoading, addedData, formConfig) : null}
      {showRemarks ? (
        <RemarkDetails
          handleSubmit={handleSubmit}
          setShowRemarks={setShowRemarks}
        />
      ) : null}
    </>
  );
};

AddUpdateForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  selectedItems: PropTypes.array,
};

export default reduxForm({})(AddUpdateForm);

function getRemarksFromInitialValues(initialValues) {
  return initialValues && initialValues.remarks ? initialValues.remarks : "";
}
function getIsNotEditable(mode, selectedItems) {
  return mode === "Update"
    ? selectedItems[0].status === "Invalid" &&
        selectedItems[0].workflowStatus === WorkflowStatuses.PENDING
    : false;
}

function renderDetails(isApiLoading, addedData, formConfig) {
  return isApiLoading ? (
    <Skeleton width="15rem" height="6rem" />
  ) : (
    <AddedDetails addedData={addedData} formConfig={formConfig} />
  );
}

function readOnlyFieldComponent(key, value) {
  return (
    <div className="p-1">
      <span className="text-base font-normal ml-2">{key} : </span>
      <span className="text-base font-semibold">{value}</span>
    </div>
  );
}

function getFormTitle(mode, title, deleteApproveRejectBtn, t) {
  if (mode === "Add") {
    return `${t("AddNew")} ${t(title)}`;
  } else if (deleteApproveRejectBtn) {
    return `${t("Delete")} ${t(title)}`;
  } else {
    return `${t("Update")} ${t(title)}`;
  }
}

function getClearCancelButtonLabelTooltip(mode, t) {
  return mode === "Add" ? t("Clear") : t("Cancel");
}

function getRejectButtonLabelTooltip(deleteApproveRejectBtn, t) {
  return deleteApproveRejectBtn ? t("Delete Reject") : t("Reject");
}

function getApproveButtonLabelTooltip(deleteApproveRejectBtn, t) {
  return deleteApproveRejectBtn ? t("Delete Approve") : t("Approve");
}

function getSubmitButtonLabelTooltip(mode, title, t) {
  return mode === "Add"
    ? `${t("Add")} ${t(title)}`
    : `${t("Update")} ${t(title)}`;
}
